/**
 * User
 */
export class User {
  /**
   * Name
   */
  name: string;

  /**
   * Password
   */
  password: string;

  /**
   * Language
   */
  languageId: string;

  /**
   * Language name
   */
  language: {
    name: string;
  };

  /**
   * Create from json
   *
   * @param json Json with data
   *
   * @return self
   */
  static createFromJson(json: object): User {
    const self = new this();

    Object.keys(json).forEach((key) => {
      self[key] = json[key];
    });

    return self;
  }
}
